<template>
  <XField
    :errors="validationErrors(formattedLabel)"
    :errorStyle="formFieldsErrorStyle"
  >
    <VSelect
      :label="parameters.config.label"
      :labelStyle="labelStyle"
      v-model="fieldValue"
      v-validate="{ required: parameters.required }"
      :inputErrorStyle="inputCustomStyles"
      :options="parameters.config.options"
      :maxHeight="maxMenuHeight"
      :openDirection="menuOpenDirection"
      :data-vv-name="formattedLabel"
      :invalid="validationHasErrors(formattedLabel)"
      :optional="isOptional"
      multiple
      @close="validate"
    />
  </XField>
</template>

<script>
import VSelect from '@plat/components/VueSelect'

import _ from 'lodash'

import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],

  components: { VSelect },

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    maxMenuHeight () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.maxHeight || 300
        : 300
    },

    menuOpenDirection () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.openDirection || ''
        : ''
    }
  },

  methods: {
    validate () {
      this.$validator.validate(this.formattedLabel)
    }
  }
}
</script>
